var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5642 17.3924L16.3566 14.1847C16.2813 14.1094 16.1791 14.067 16.0726 14.067C15.9662 14.067 15.864 14.1094 15.7888 14.1847L15.5546 14.4197L14.1481 13.0123C15.2971 11.4768 15.5866 9.46249 14.9161 7.66578C14.2457 5.86904 12.7075 4.53634 10.8337 4.12882C8.9596 3.7213 7.00677 4.2946 5.65066 5.65072C4.29455 7.00684 3.72124 8.95951 4.12876 10.8337C4.53628 12.7076 5.86897 14.2458 7.66572 14.9162C9.46262 15.5866 11.477 15.2971 13.0122 14.1482L14.4195 15.5564L14.1845 15.7905H14.1847C14.1093 15.8657 14.0669 15.9677 14.0669 16.0743C14.0669 16.1808 14.1093 16.2829 14.1847 16.3583L17.3923 19.5659V19.5657C17.7817 19.9455 18.3431 20.0908 18.8679 19.9479C19.3929 19.8048 19.8028 19.3949 19.9459 18.8699C20.0889 18.3451 19.9437 17.7837 19.5639 17.3943L19.5642 17.3924ZM5.64784 9.65719C5.64784 8.59369 6.0703 7.57394 6.82219 6.82201C7.57413 6.07007 8.59388 5.64765 9.65738 5.64765C10.7207 5.64765 11.7405 6.07011 12.4926 6.82201C13.2445 7.57394 13.6669 8.59369 13.6669 9.65719C13.6669 10.7205 13.2445 11.7403 12.4926 12.4924C11.7405 13.2443 10.7207 13.6667 9.65738 13.6667C8.59434 13.6654 7.57531 13.2425 6.82353 12.4909C6.0719 11.7393 5.64902 10.7201 5.64784 9.65719Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoop);
export default __webpack_public_path__ + "static/media/search_loop.96d6c0ed7bf7fe46923920209d203381.svg";
export { ForwardRef as ReactComponent };